import { CanLoad, UrlSegment, Route } from '@angular/router';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanLoad {
  constructor(private authService: AuthService) {}

  public canLoad(
    route: Route,
    segment: UrlSegment[],
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isLogged = this.authService.isLoggedIn();

    if (isLogged) {
      return true;
    }

    this.authService.logout();
    return false;
  }
}
